<template>
  <div class="font-medium border-b w-[105%] -ml-[2.5%] text-xl pb-2">
    <span class="ml-2">{{ $t("Create New Workspace") }}</span>
  </div>
  <CompaniesSelect
    class="mt-4"
    :multi-select="false"
    :companies="selected_company ? [selected_company] : []"
    :label="$t('Select') + ' ' + $t('Company/Opportunity')"
    @changed="
      ($event) => {
        handleSetConmpaniesList($event)
      }
    " />

  <!-- <div class="mt-5">
    <span class="mt-5 mr-2">Start with a template</span>
    <input v-model="start_with_template" type="checkbox" class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration" />
  </div>
  <SelectInput
    v-if="start_with_template"
    v-model="selected_template"
    :allow-null="false"
    :items="WORKSAPCE_TEMPLATES"
    name="Selecte Template"
    label-attr="name"
    value-attr="id"
    :classes="`w-full mb-6 mt-6`"
    :is-box-background="true"
    label="Select Template"
    :show-label="true"
    @update:currentItem="
      ($event) => {
        selected_template = $event
      }
    "
  /> -->
  <div v-if="selected_template" class="p-2 mt-4 border rounded-lg text">
    <div class="mb-2 text-lg font-medium">
      {{ WORKSAPCE_TEMPLATES.find((t) => t.id == selected_template).name }}
    </div>
    <div>
      {{ WORKSAPCE_TEMPLATES.find((t) => t.id == selected_template).description }}
    </div>
  </div>
  <div class="flex flex-row justify-between w-full gap-2 mt-3">
    <button type="button" class="w-1/2 m-0 cancel-btn border-light-divider-border dark:border-dark-divider-border" @click="$emit('cancel')">
      {{ $t("Cancel") }}
    </button>
    <button :disabled="!required_filled" class="w-1/2 primary-btn" @click="handleCreateWorkspace">
      <span class="mr-5 whitespace-nowrap"> {{ $t("Create Workspace") }} </span>
    </button>
  </div>
</template>

<script>
import CompaniesSelect from "@/components/shared/CompaniesSelect.vue"
import { getWorkspaceTemplates, getPageDefaulWorkspaceTemplates } from "@/store/constants/templates"

export default {
  name: "NewWorkspaceForm",
  components: { CompaniesSelect },
  props: {},
  emits: ["cancel", "done"],
  data() {
    return {
      selected_company: null,
      start_with_template: false,
      selected_template: null,
      WORKSAPCE_TEMPLATES: []
    }
  },
  computed: {
    required_filled() {
      if (!this.selected_company) {
        return false
      } else if (this.start_with_template) {
        if (!this.selected_template) {
          return false
        } else {
          return true
        }
      }
      return true
    }
  },
  watch: {
    selected_company() {
      if (this.selected_company) {
        this.WORKSAPCE_TEMPLATES = getWorkspaceTemplates(this.selected_company.id)
      }
    },
    start_with_template() {
      if (!this.start_with_template) {
        this.selected_template = null
      }
    }
  },

  created() {},

  methods: {
    handleSetConmpaniesList(e) {
      this.selected_company = e[0] ? e[0] : null
    },
    handleCreateWorkspace() {
      const workspace_data = {
        record: this.selected_company.id,
        name: `${this.$utils.getRecordName(this.selected_company)} ` + this.$t("Workspace"),
        description: this.$t("Workspace for") + ` ${this.$utils.getRecordName(this.selected_company)}`
      }

      if (this.selected_template) {
        const workspace_template = this.$utils.clone(getPageDefaulWorkspaceTemplates(this.selected_company.id))
        const selected_template_pages = this.WORKSAPCE_TEMPLATES.find((t) => t.id == this.selected_template).pages

        selected_template_pages.forEach((template) => {
          const index = workspace_template.findIndex((t) => t.id == template.id)

          workspace_template.splice(index, 1, { ...workspace_template[index], is_visible: true, layout: template.layout })
        })
        workspace_data["layout"] = workspace_template
      } else {
        const workspace_template = this.$utils.clone(getPageDefaulWorkspaceTemplates(this.selected_company.id))
        workspace_template[0].is_visible = true

        workspace_data["layout"] = workspace_template
      }
      this.$store.dispatch("data/createWorkspace", workspace_data).then((res) => {
        this.$router.push(`/workspace/edit/${res.data.short_id}`)
        this.$emit("done")
      })
    }
  }
}
</script>
